/**
 * Live Markup / Margin helpers for the Add Product pricing section.
 *
 * Markup = profit as a percentage of cost   → (price - cost) / cost * 100
 * Margin = profit as a percentage of price  → (price - cost) / price * 100
 *
 * Both return an empty string when the inputs can't produce a meaningful
 * percentage (missing values, or a zero denominator), so the UI can render a
 * blank cell rather than "NaN" / "Infinity".
 */

export const computeMarkup = (cost: number, price: number): string => {
    if (!Number.isFinite(cost) || !Number.isFinite(price) || cost <= 0) {
        return "";
    }
    return formatPercent(((price - cost) / cost) * 100);
};

export const computeMargin = (cost: number, price: number): string => {
    if (!Number.isFinite(cost) || !Number.isFinite(price) || price <= 0) {
        return "";
    }
    return formatPercent(((price - cost) / price) * 100);
};

const formatPercent = (value: number): string => `${value.toFixed(1)}%`;
